import {defineAsyncComponent} from 'vue';

export const HitDropdown = defineAsyncComponent(
  () => import('./HitDropdown.vue'),
);

export {DropdownItem} from './DropdownItem';
